import React, { createContext, useState, useContext, useMemo, useEffect } from 'react';
import { ThemeOptions } from '@mui/material/styles'; // Импортируем ThemeOptions
import { getTheme } from 'shared/config/theme/theme'; // Убедитесь, что getTheme и ThemeColors экспортируются

type ThemeMode = 'light' | 'dark';

interface ThemeContextProps {
    themeMode: ThemeMode;
    setThemeMode: (mode: ThemeMode) => void;
    theme: ThemeOptions; // Используем ThemeOptions из MUI
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

// ThemeProvider
interface ThemeProviderProps {
    children: React.ReactNode;
    lightColorTheme: any; // Типизируем lightColorTheme
    darkColorTheme: any; // Типизируем darkColorTheme
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, lightColorTheme, darkColorTheme }) => {
    const [themeMode, setThemeMode] = useState<ThemeMode>('light'); // Начальное значение - light

    useEffect(() => {
        const storedMode = localStorage.getItem('themeMode') as ThemeMode | null;
        if (storedMode === 'dark' || storedMode === 'light') {
            setThemeMode(storedMode);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('themeMode', themeMode);
    }, [themeMode]);

    const theme = useMemo(() => {
        const selectedTheme: any = themeMode === 'dark' ? darkColorTheme : lightColorTheme; // Добавляем типизацию
        const selectedThemeTh: ThemeOptions = getTheme(selectedTheme); // Добавляем типизацию и сохраняем в переменную с другим названием
        console.log('selectedThemeTh', selectedThemeTh);
        return selectedThemeTh;
    }, [themeMode, lightColorTheme, darkColorTheme]); // Добавляем lightColorTheme и darkColorTheme в зависимости

    const value = useMemo(() => ({
        themeMode,
        setThemeMode,
        theme,
    }), [themeMode, theme]);

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};

// Хук для использования темы
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
